export default __webpack_public_path__ + "static/media/2016.eae6e122.png";